"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionContext = exports.AssertResultList = void 0;
var _webautoAuthCore = require("@tier4/webauto-auth-core");
const unixTimestamp = (delta = 0) => Math.floor(Date.now() / 1000) + delta;
const mergeScope = scopes => Array.from(new Set(scopes)).sort().join(" ");
const mergeAssertRequest = reqs => ({
  scope: mergeScope(reqs.map(req => req.scope ?? "")),
  feature_scope: mergeScope(reqs.map(req => req.feature_scope ?? "")),
  client_application_scope: mergeScope(reqs.map(req => req.client_application_scope ?? ""))
});
const separateAssertResultByRequest = (req, res) => {
  return req.map(req => {
    const scope = req.scope ?? "";
    const feature_scope = req.feature_scope ?? "";
    const client_application_scope = req.client_application_scope ?? "";
    return {
      result: scope.split(" ").every(s => res.scope.includes(s)) && feature_scope.split(" ").every(s => res.feature_scope.includes(s)) && client_application_scope.split(" ").every(s => res.client_application_scope.includes(s)),
      scope,
      feature_scope,
      client_application_scope
    };
  });
};
class AssertResultList {
  constructor(list) {
    this.list = list;
  }
  get(req) {
    const scope = req.scope ?? "";
    const feature_scope = req.feature_scope ?? "";
    const client_application_scope = req.client_application_scope ?? "";
    return this.list.find(r => r.scope === scope && r.feature_scope === feature_scope && r.client_application_scope === client_application_scope) ?? null;
  }
}
exports.AssertResultList = AssertResultList;
class PermissionContext {
  expiredAt = 0;
  introspection = null;
  constructor(tokenSource, tokenService, expiredInSeconds) {
    this.tokenSource = tokenSource;
    this.tokenService = tokenService;
    this.expiredInSeconds = expiredInSeconds;
  }
  async assert(req) {
    const introspection = await this.getValidIntrospection();
    const res = await this.tokenService.assert(_webautoAuthCore.AssertRequestBuilder.tokenScope({
      token_scope: (0, _webautoAuthCore.preFilterScope)(introspection.scope, req.scope ?? ""),
      scope: req.scope ?? "",
      token_feature_scope: (0, _webautoAuthCore.preFilterScope)(introspection.feature_scope, req.feature_scope ?? ""),
      feature_scope: req.feature_scope,
      token_client_application_scope: (0, _webautoAuthCore.preFilterScope)(introspection.client_application_scope, req.client_application_scope ?? ""),
      client_application_scope: req.client_application_scope
    }), true);
    return {
      result: res.result,
      scope: res.scope,
      feature_scope: res.feature_scope,
      client_application_scope: res.client_application_scope
    };
  }
  async batchAssert(reqs) {
    const res = await this.assert(mergeAssertRequest(reqs));
    return new AssertResultList(separateAssertResultByRequest(reqs, res));
  }
  expired() {
    return this.expiredAt < unixTimestamp();
  }
  async getValidIntrospection() {
    if (!this.expired() && this.introspection !== null) {
      return this.introspection;
    }
    return this.introspect();
  }
  async introspect() {
    const token = await this.tokenSource.getToken();
    const introspection = await this.tokenService.introspect({
      token: token.accessToken,
      token_type_hint: "access_token"
    });
    if (!introspection.active) {
      throw new Error("token is not active");
    }
    this.expiredAt = Math.min(unixTimestamp(this.expiredInSeconds), introspection.exp);
    this.introspection = introspection;
    return introspection;
  }
}
exports.PermissionContext = PermissionContext;
//# sourceMappingURL=PermissionContext.js.map